export interface JwtPayload {
  sub?: string;
  uid?: string;
  ev?: boolean;
  exp?: number;
}

export function parseJwt(token: string | null | undefined): JwtPayload | null {
  const parts = token?.split('.') ?? [];
  if (parts.length < 2) return null;
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    return JSON.parse(atob(padded)) as JwtPayload;
  } catch {
    return null;
  }
}
